import React, { useRef, useState } from 'react'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as constants from "../constants";
import { t } from 'i18next';
import { useSnackbar } from 'notistack';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import CustomImageComponent from './CustomImageComponent';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const ContactUsLeft = ({ heading = true }) => {
    const countryPrefix = useCountryPrefix();

    const { executeRecaptcha } = useGoogleReCaptcha();

    let apiUrl = process.env.REACT_APP_API_URL;

    const nameRef = useRef();
    const messageRef = useRef();

    const [phone, setPhone] = useState("");

    const [errors, setErrors] = useState({
        name: false,
        phone: false
    });
    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);

    const validateForm = () => {

        const name = nameRef.current.value.trim();
        let hasError = false;
        let updatedErrors = { name: false, phone: false };
        const alphaRegex = /^[A-Za-z\s]+$/;

        if (!name || !alphaRegex.test(name)) {
            updatedErrors.name = true;
            hasError = true;
        }

        const digitsOnly = phone.replace(/\D/g, ''); // removes everything except digits
        const hasValidLength = digitsOnly.length >= 9; // e.g., +20 (2 digits) + 4 local = 6


        if (!phone || !hasValidLength) {
            updatedErrors.phone = true;
            hasError = true;
        }

        setErrors(updatedErrors);
        return !hasError;
    };


    const submitContactDetails = async () => {

        setIsLoading(true)

        if (!validateForm()) {
            setIsLoading(false)
            return;
        }

        if (!executeRecaptcha) {
            enqueueSnackbar('CAPTCHA not ready. Try again later.', { variant: 'error' });
            setIsLoading(false)
            return;
        }
        const token = await executeRecaptcha("contact_form");
        const captchaResult = await verifyCaptcha(token);
        if (!captchaResult.success || captchaResult.score < 0.5) {
            enqueueSnackbar('reCAPTCHA verification failed. Please try again.', { variant: 'error' });
            setIsLoading(false)
            return;
        }
        const payload = {
            name: nameRef.current.value.trim(),
            phone: phone,
            message: messageRef.current.value.trim(),
        };
        try {
            const resInquiry = await fetch(`${apiUrl}${constants.contactdetails}?region_id=${countryPrefix}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const result = await resInquiry.json();

            if (result.status === 200) {
                nameRef.current.value = "";
                setPhone("+20");
                messageRef.current.value = "";
                setErrors({ name: false, phone: false }); // reset errors

                enqueueSnackbar('Application submitted successfully.', { variant: 'success' });


            } else {
                enqueueSnackbar(`Failed to submit application. ${result.message}`, { variant: 'error' });

                throw new Error('Failed to submit application');
            }
        } catch (error) {
            console.error('Error:', error);
        }
        setIsLoading(false)
    }



    const verifyCaptcha = async (token) => {
        try {
            const res = await fetch(apiUrl + constants.verifycaptcha, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token }),
            });

            return await res.json();
        } catch (error) {
            console.error('Error:', error);
        }

    }

    return (
        <>
            <div className="form-wrapper">
                {heading ? (<>
                    <h2>{t("consultation_request")}</h2>
                    <p className="mb-3">{t("consultation_request_detail")}</p>
                </>) : ""}
                <div className="mb-4">
                    <label className="form-label">{t("name")}<span>*</span></label>
                    <input id="name"
                        type="text"
                        className={"form-control"}
                        autoComplete="off"
                        maxLength={50}
                        placeholder={t("name_placeholder")} ref={nameRef}
                        onBlur={() => {
                            const name = nameRef.current.value.trim();
                            const alphaRegex = /^[A-Za-z\s]+$/;
                            setErrors(prev => ({
                                ...prev,
                                name: !name || !alphaRegex.test(name)
                            }));
                        }}
                    />
                    {errors.name && (
                        <small className="text-danger">{t("name_required")}</small>
                    )}
                </div>
                <div className="mb-4">
                    <label className="form-label">{t("phone")}<span>*</span></label>
                    <PhoneInput
                        id="mobile_number"
                        type="text"
                        country={'eg'}
                        //maxLength={17}
                        inputClass={`w-100 ps-5 ${errors.phone ? 'is-invalid' : ''}`}
                        placeholder={t("phone_placeholder")}
                        value={phone}
                        onChange={(value, data, event, formattedValue) => setPhone(formattedValue)}
                        inputProps={{
                            name: 'phone',
                            id: 'mobile_number',
                            autoComplete: 'off',

                        }}
                    />
                    {errors.phone && (
                        <small className="text-danger">{t("phone_required")}</small>
                    )}
                </div>
                <div className="mb-4">
                    <label className="form-label">{t("message_optional")}</label>
                    <textarea id="message" placeholder={t("message_placeholder")}
                        className="form-control form-control-textarea"
                        ref={messageRef}></textarea>
                </div>
                <div className="">
                    <button type="button" className="theme-btn theme-btn-secondary" onClick={submitContactDetails} disabled={isLoading}>
                        {isLoading ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (
                            <>
                                {t("submit")}
                                <CustomImageComponent src={"/assets/img/link-arrow.svg"} alt={"link-arrow"} />
                            </>
                        )}
                    </button>
                </div>
            </div>
        </>
    )
}

export default ContactUsLeft